import { Hand, Gem, Frame } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { Reveal } from "../hooks/useScrollReveal";

const IMG_LARGE =
  "https://images.unsplash.com/photo-1583329550487-0fa300a4cd1a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxhcmNoaXRlY3R1cmFsJTIwaW50ZXJpb3IlMjBuYXR1cmFsJTIwbGlnaHR8ZW58MHx8fHwxNzgyOTk0MzMxfDA&ixlib=rb-4.1.0&q=85";
const IMG_SMALL =
  "https://images.unsplash.com/photo-1573345173719-5fbd4783d3c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwY29uY3JldGUlMjB3YWxsJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzgyOTk0MzMxfDA&ixlib=rb-4.1.0&q=85";

export default function About() {
  const { t } = useI18n();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-[#f9f8f5] py-24 md:py-36"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-14 md:gap-16 items-center">
        {/* Image composition */}
        <Reveal className="md:col-span-6 relative order-1">
          <div className="relative aspect-[4/5] w-full max-w-[520px] mx-auto md:ml-0">
            <img
              src={IMG_LARGE}
              alt="Detail kamenné textury"
              loading="lazy"
              className="w-full h-full object-cover shadow-[0_30px_80px_-40px_rgba(37,37,37,0.35)]"
            />
            <div className="absolute -right-4 -bottom-10 md:-right-14 md:-bottom-16 w-[55%] max-w-[280px] aspect-[3/4]">
              <img
                src={IMG_SMALL}
                alt="Ruční betonový reliéf"
                loading="lazy"
                className="w-full h-full object-cover shadow-[0_24px_60px_-30px_rgba(37,37,37,0.35)]"
              />
            </div>
          </div>
        </Reveal>

        {/* Text */}
        <Reveal className="md:col-span-6 order-2 md:pl-8 lg:pl-16">
          <div className="eyebrow mb-6" data-testid="about-eyebrow">
            {t.about.eyebrow}
          </div>
          <h2
            data-testid="about-title"
            className="font-serif-hero text-[#252525] text-[34px] sm:text-[42px] md:text-[52px] leading-[1.1] tracking-[-0.005em]"
          >
            {t.about.title}
          </h2>
          <p className="mt-8 text-[15px] leading-[1.75] text-[#4a4a45]">{t.about.p1}</p>
          <p className="mt-5 text-[15px] leading-[1.75] text-[#4a4a45]">{t.about.p2}</p>
          <p className="mt-8 font-serif italic text-[#6f6f6a] text-[15px]">{t.about.signature}</p>

          <div className="mt-12 h-px bg-[#e6e1d6]" />

          <div className="mt-8 grid grid-cols-3 gap-2">
            <Benefit icon={Hand} label={t.about.benefits.b1} testId="about-benefit-1" />
            <Benefit icon={Gem} label={t.about.benefits.b2} testId="about-benefit-2" withDividers />
            <Benefit icon={Frame} label={t.about.benefits.b3} testId="about-benefit-3" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}

function Benefit({ icon: Icon, label, testId, withDividers }) {
  return (
    <div
      data-testid={testId}
      className={`flex flex-col items-center text-center gap-3 px-2 ${
        withDividers ? "border-x border-[#e6e1d6]" : ""
      }`}
    >
      <Icon size={26} strokeWidth={1.25} className="text-[#b86a55]" />
      <div className="text-[11px] md:text-[12px] tracking-[0.16em] uppercase text-[#4a4a45] font-medium">
        {label}
      </div>
    </div>
  );
}
